import { Dropzone, Form, Message } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

interface RegiePieceJointeListItemFormProps {
  titre?: string;
  fichier?: File;
  errors?: Record<string, string>;
  onChange: (e) => void;
  onError: (errorsToAdd, errorsToRemove) => void;
}

const RegiePieceJointeListItemForm = (props: RegiePieceJointeListItemFormProps) => {
  const { errors, titre, fichier, onChange, onError } = props;

  const handleUpload = React.useCallback(
    (acceptedFiles) => {
      // RAZ les erreurs
      onError(null, errors);
      onChange({ target: { name: 'fichier', value: acceptedFiles[0] } });
    },
    [errors, onChange, onError],
  );

  const handleChange = React.useCallback(
    (e) => {
      // RAZ les erreurs
      onError(null, errors);
      onChange(e);
    },
    [errors, onChange, onError],
  );

  const handleFileRemove = React.useCallback(() => {
    // RAZ les erreurs
    onError(null, errors);
    onChange({ target: { name: 'fichier', value: null } });
  }, [onChange, onError, errors]);

  return (
    <Form>
      <Form.Input
        input={{ 'data-testid': 'input-pj-titre' }}
        label="Titre"
        name="titre"
        value={titre}
        onChange={handleChange}
        required
        error={!_.isNil(errors?.titre)}
      />
      {_.isNil(fichier) ? (
        <Form.Field required>
          <label>Document</label>
          <Dropzone
            error={!_.isNil(errors?.document)}
            withIcon
            // @ts-expect-error
            onDrop={handleUpload}
          />
        </Form.Field>
      ) : (
        <Message
          {...(_.isNil(errors?.document)
            ? {
                info: true,
                content: `${fichier.name}`,
              }
            : {
                error: true,
                content: (
                  <>
                    {fichier.name}
                    <br />
                    <br />
                    {errors.document}
                  </>
                ),
              })}
          icon="file"
          header="Fichier téléversé :"
          onDismiss={handleFileRemove}
        />
      )}
    </Form>
  );
};

export default RegiePieceJointeListItemForm;
